import { render } from "./VirtualPackingSlipDetailsContainer.vue?vue&type=template&id=3d2ae8a8"
import script from "./VirtualPackingSlipDetailsContainer.vue?vue&type=script&lang=js"
export * from "./VirtualPackingSlipDetailsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__